import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#8070DD",
      d: "M0 4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F8F9FB",
      "fill-rule": "evenodd",
      d: "M3.5 13.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25zm1.25 2.75A2.75 2.75 0 0 1 2 13.5v-7a2.75 2.75 0 0 1 2.75-2.75h10.5A2.75 2.75 0 0 1 18 6.5v7a2.75 2.75 0 0 1-2.75 2.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }